module.exports = __webpack_public_path__ + "img/video2.fb0f38b9.jpg";